import { GtmEvents } from '@/gtm/gtm-events';

export class TypGtmEvents extends GtmEvents {
  eventCategory = 'СобытияСпасибоЗаПокупку';

  payOnline({ orderNumber }) {
    return this.gtmEvent({
      eventAction: 'TYP_ОплатитьОнлайн',
      eventLabel: orderNumber,
    })
  }

  payFps({ orderNumber }) {
    return this.gtmEvent({
      eventAction: 'TYP_ОплатитьСБП',
      eventLabel: orderNumber,
    })
  }

  paidOnline({ orderNumber }) {
    return this.gtmEvent({
      eventAction: 'TYP_ЗаказОплаченОнлайн',
      eventLabel: orderNumber,
    })
  }

  paidFps({ orderNumber }) {
    return this.gtmEvent({
      eventAction: 'TYP_ЗаказОплаченСБП',
      eventLabel: orderNumber,
    })
  }
}

export const typGtmEvents = new TypGtmEvents();
